import React from 'react';
import ExploreIcon from '@mui/icons-material/Explore';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import PeopleIcon from '@mui/icons-material/People';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import ShieldIcon from '@mui/icons-material/Shield';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import LoginIcon from '@mui/icons-material/Login';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import GroupsIcon from '@mui/icons-material/Groups';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';

import { isOwner } from '../../utils/owner';

export function getNavConfig(userInfo) {
  const isLoggedIn = userInfo && !userInfo.isAnon;

  const items = [
    {
      title: 'Explore',
      path: '/',
      icon: (active) => active ? <ExploreIcon sx={{ fontSize: 22 }} /> : <ExploreOutlinedIcon sx={{ fontSize: 22 }} />,
    },
    {
      title: 'Discover',
      path: '/discover',
      icon: (active) => active ? <PeopleIcon sx={{ fontSize: 22 }} /> : <PeopleOutlinedIcon sx={{ fontSize: 22 }} />,
    },
    {
      title: 'Create',
      path: '/new',
      icon: (active) => active ? <AddCircleIcon sx={{ fontSize: 22 }} /> : <AddCircleOutlineIcon sx={{ fontSize: 22 }} />,
    },
    {
      title: 'Challenge',
      path: '/play',
      icon: (active) => active ? <EmojiEventsIcon sx={{ fontSize: 22 }} /> : <EmojiEventsOutlinedIcon sx={{ fontSize: 22 }} />,
    },
    ...(isLoggedIn ? [
      {
        title: 'Saved',
        path: '/saved',
        icon: (active) => active ? <BookmarkIcon sx={{ fontSize: 22 }} /> : <BookmarkBorderIcon sx={{ fontSize: 22 }} />,
      },
      {
        // Social hub. `badgeKey` is read by NavSection and resolved against
        // the social redux slice, so the pending follow-request count rides
        // the nav row itself rather than needing a separate surface.
        title: 'People',
        path: '/people',
        badgeKey: 'followRequests',
        icon: (active) => active ? <GroupsIcon sx={{ fontSize: 22 }} /> : <GroupsOutlinedIcon sx={{ fontSize: 22 }} />,
      },
      // Messages deliberately has NO sidebar row (product decision,
      // 2026-08-05): the navbar MessagesButton beside the bell is the one
      // desktop entry point, matching where the unread badge lives. Phones
      // reach the inbox via the People hub + the BottomNav People badge.
    ] : []),
    isLoggedIn ? {
      title: 'Profile',
      path: '/u/me',
      icon: (active) => active ? <PersonIcon sx={{ fontSize: 22 }} /> : <PersonOutlinedIcon sx={{ fontSize: 22 }} />,
    } : {
      title: 'Sign in',
      path: '/login',
      icon: (active) => <LoginIcon sx={{ fontSize: 22 }} />,
    }
  ];

  if (isOwner(userInfo)) {
    return [
      ...items,
      {
        title: 'Owner',
        path: '/admin',
        icon: (active) => active ? <ShieldIcon sx={{ fontSize: 22 }} /> : <ShieldOutlinedIcon sx={{ fontSize: 22 }} />,
      },
    ];
  }
  return items;
}

export default getNavConfig;
